import { COBStep, getCommonReachableSteps } from "../ClientOnboarding.common.utils";
export function getVendorGradientStyle(branding) {
  return {
    background: "linear-gradient(270deg, ".concat(branding.backgroundGradientStart, " 0%, ").concat(branding.backgroundGradientEnd, " 100%)")
  };
}

/**
 * Returns the reachable inner steps for V2 client onboarding.
 * Starts with 'introduction' (instead of 'welcome' which is the cover page in V2).
 * Excludes 'allSet' as V2 handles that transition separately.
 */
export function getReachableInnerSteps(relationship, MULTIPLE_LEGAL_TERMS_DOCUMENTS) {
  return [COBStep.introduction, ...getCommonReachableSteps(relationship, MULTIPLE_LEGAL_TERMS_DOCUMENTS)];
}
export function getNextStepButtonText(step, relationship, MULTIPLE_LEGAL_TERMS_DOCUMENTS) {
  const reachableSteps = getReachableInnerSteps(relationship, MULTIPLE_LEGAL_TERMS_DOCUMENTS);
  const currentStepIndex = reachableSteps.indexOf(step);
  if (currentStepIndex === -1) {
    return 'Next';
  }
  const nextStep = reachableSteps[currentStepIndex + 1];
  if (!nextStep) {
    return 'Sign & approve';
  }
  if (nextStep === COBStep.selectAPackage) {
    return 'Select a package';
  }
  if (nextStep === COBStep.paymentMethod) {
    return 'Add a payment method';
  }
  return 'Next';
}